export enum ReactionType {
  LIKE = 'LIKE', // "Like" in the UI
  PRAISE = 'PRAISE', // "Celebrate" in the UI
  MAYBE = 'MAYBE', // "Curious" in the UI
  EMPATHY = 'EMPATHY', // "Love" in the UI
  INTEREST = 'INTEREST', // "Insightful" in the UI
  APPRECIATION = 'APPRECIATION', // "Support" in the UI
  ENTERTAINMENT = 'ENTERTAINMENT', // "Funny" in the UI
}
